<ng-form #stepForm="ngForm">
    <!-- business details -->
    <h3 class="h3">{{'Business Details' | translate}}</h3>

    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
        <input class="input p-b-6-m p-b-5-s p-t-7-s"
               type="text"
               name="business_type"
               required
               sl-input="business_type"
               [(ngModel)]="data.business_type"
               [muiInput]="'Type of Business/Premises' | translate">
    </input-wrap>

    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
        <select class="select"
                name="premises_type"
                required
                [muiInput]="'Premises owned or rented' | translate"
                [(ngModel)]="data.premises_type">
            @for (option of premisesOptions; track $index) {
            <option [value]="option.id">{{option.title | translate}}</option>
            }
        </select>
    </input-wrap>

    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
        <input class="input p-b-6-m p-b-5-s p-t-7-s"
               type="text"
               name="business_age"
               required
               sl-input="business_age"
               [(ngModel)]="data.business_age"
               [muiInput]="'Length of time business has traded' | translate">
    </input-wrap>

    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
        <input class="input p-b-6-m p-b-5-s p-t-7-s"
               type="text"
               name="acc_cont_name"
               required
               sl-input="acc_cont_name"
               [(ngModel)]="data.acc_cont_name"
               [muiInput]="'Accounts Contact Name' | translate">
    </input-wrap>

    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
        <input class="input p-b-6-m p-b-5-s p-t-7-s"
               type="email"
               loqateEmail
               name="acc_cont_email"
               required
               validatePattern="email"
               sl-input="acc_cont_email"
               [(ngModel)]="data.acc_cont_email"
               [muiInput]="'Accounts Contact Email Address' | translate">
    </input-wrap>

    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
        <input class="input p-b-6-m p-b-5-s p-t-7-s"
               type="text"
               name="acc_cont_phone"
               validatePattern="telephone"
               inputmode="tel"
               required
               autocomplete="tel"
               sl-input="acc_cont_phone"
               [(ngModel)]="data.acc_cont_phone"
               [muiInput]="'Accounts Contact Phone Number' | translate">
    </input-wrap>

    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
        <input class="p-b-6-m p-b-5-s p-t-7-s input no-spinner"
               type="number"
               name="max_credit"
               sl-input="max_credit"
               (keydown)="keydownHandle($event)"
               [(ngModel)]="data.max_credit"
               [muiInput]="'Maximum credit required per month' | translate">
    </input-wrap>

    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
        <textarea class="textarea p-b-6-m p-b-5-s p-t-7-s"
                  style="resize:none;"
                  name="major_brands"
                  required
                  sl-input="major_brands"
                  [(ngModel)]="data.major_brands"
                  [muiInput]="'Name major brands you stock' | translate"></textarea>
    </input-wrap>
</ng-form>